import { render, staticRenderFns } from "./smeRefer.vue?vue&type=template&id=fcd273d4&scoped=true&"
import script from "./smeRefer.vue?vue&type=script&lang=js&"
export * from "./smeRefer.vue?vue&type=script&lang=js&"
import style0 from "./smeRefer.vue?vue&type=style&index=0&id=fcd273d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd273d4",
  null
  
)

export default component.exports